import {v4 as uuidv4} from 'uuid';

export function genNewId(){
    return uuidv4()
}